import {
  Button,
  Col,
  Form,
  Row,
  InputGroup,
  Card,

} from "react-bootstrap";
import "../../../asset/css/signIn.css";
import sprintlogo from "../../../asset/images/sprintbanner.png";
import orgLogo from "../../../asset/images/GS_Logo.png";
import orbitLogo from "../../../asset/images/Orbit Full Logo.png";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import UserService from "../../../service/UserService";
// import { register } from "../../api/loginRegister";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const SignIn = () => {
  const [username, setUsername] = useState("");

  // const [showSignup, setShowSignup] = useState(false);
  const [isLoginForm] = useState(true);
  // const [nameError, setNameError] = useState("");
  // const [name, setName] = useState("");

  // const [emailError, setEmailError] = useState("");
  // const [mobileError, setMobileError] = useState("");
  // const [passwordError, setPasswordError] = useState("");
  const [password, setPassword] = useState("");

  // const [email, setEmail] = useState("");
  // const [mobile, setMobile] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  // const [isSignupLoading, setIsSignupLoading] = useState(false);

  const navigate = useNavigate();

  // const [signupData, setSignupData] = useState({
  //   name: "",
  //   email: "",
  //   mobile: "",
  //   password: "",
  // });

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      toast.error("Please enter both email and password");
      return;
    }

    try {
      const response = await UserService.login(username, password);

      const data = response?.data || response;
      console.log("login res=", data)
      console.log("Full userInfo:", JSON.stringify(data.userInfo, null, 2)); // ADD THIS LINE

      if (!data) {
        toast.error("No response received from server. Please try again.");
        return;
      }

      if (data.statusCode === 200 || response.status === 200) {
        toast.success("Login successful!");

        localStorage.setItem("token", data.token);
        // decode JWT and save allowedPages
        const payload = JSON.parse(atob(data.token.split('.')[1]));
        localStorage.setItem("allowedPages", JSON.stringify(payload.allowedPages || []));
        localStorage.setItem("refreshToken", data.refreshToken);

        localStorage.setItem("email", data.userInfo.email);
        window.dispatchEvent(new Event("storage"));
        localStorage.setItem("roleId", data.userInfo?.role?.id);
        localStorage.setItem("allowedPages", JSON.stringify(data.allowedPages || []));

        localStorage.setItem("userName", data.userInfo?.name);
        localStorage.setItem("id", data.userInfo?.id);


        const roleId = data.userInfo?.role?.id;


        switch (roleId) {
          case 1:
            navigate("/reporting/Dashboard");
            break;
          case 2: // ADMIN
            navigate("/reporting/Dashboard");
            break;
          case 3: // EMPLOYEE
            navigate("/employee-dashboard");
            break;
          case 5: // HR
            navigate("/reporting/Dashboard");
            break;
          case 6: // TEAM_LEAD
            navigate("/reporting/Dashboard");
            break;
          default:
            console.warn("Unknown role ID:", roleId);
            navigate("/");
            break;
        }
      } else {
        const message =
          data.message || "Login failed. Please check your credentials.";

        if (message.toLowerCase().includes("pending admin verification")) {
          toast.error("Your account is pending admin verification.");
        } else {
          toast.error(message);
        }
      }
    } catch (error) {
      console.error("Login Error:", error);

      const message =
        error.response?.data?.message ||
        error.message ||
        "Login failed. Please try again.";

      const msg = message.toLowerCase();

      if (msg.includes("pending admin verification")) {
        toast.warning("Your account is pending admin verification.");
      } else if (msg.includes("incorrect password")) {
        toast.error("Incorrect password");
      } else if (msg.includes("email not registered")) {
        toast.error("Email not registered");
      } else {
        toast.error(message);
      }
    }
  };

  return (
    <>
      <div className="login-container" style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>

        {/* TOP NAVBAR */}
<div className="login-navbar">
  <div className="login-left-brand">
    <img src={orgLogo} alt="logo" className="login-left-brand-logo" />
    <div>
      <div className="login-navbar-brand">Global Solutions Orbit</div>
      <div className="login-navbar-sub">orbit.globsolutions.in</div>
    </div>
  </div>
  <img src={orbitLogo} alt="Orbit" className="login-navbar-orbit-logo" />
  <div className="login-navbar-right-spacer"></div>
</div>
        {/* MAIN BODY */}
        <div className="login-main-body">
          <Row className="g-0 w-100">

            {/* LEFT PANEL */}
            <Col md={7} className="d-none d-md-flex">
              <div className="bg_card w-100">

                {/* Main content */}
                <div>
                  <div className="login-pill">Internal Productivity Platform</div>

                  <h1 className="login-left-headline">
                    Projects. Tickets. Teams. Reports.
                  </h1>
                  <p className="login-left-sub">All connected in one workspace.</p>
                  <p className="login-left-desc">
                    Manage sprint planning, track tickets, monitor team activity, submit daily
                    reports, and streamline project execution from a single platform.
                  </p>

                  <div className="login-feature-grid">
                    <div className="login-feature-card">
                      <div className="login-feature-icon">⚡</div>
                      <div className="login-feature-title">Sprint Management</div>
                      <p className="login-feature-desc">Plan, prioritize, and track development work.</p>
                    </div>
                    <div className="login-feature-card">
                      <div className="login-feature-icon">🎫</div>
                      <div className="login-feature-title">Ticketing System</div>
                      <p className="login-feature-desc">Manage issues, bugs, enhancements, and requests.</p>
                    </div>
                    <div className="login-feature-card">
                      <div className="login-feature-icon">📈</div>
                      <div className="login-feature-title">Employee Activity</div>
                      <p className="login-feature-desc">Track daily work reports and productivity updates.</p>
                    </div>
                    <div className="login-feature-card">
                      <div className="login-feature-icon">📊</div>
                      <div className="login-feature-title">Reports & Insights</div>
                      <p className="login-feature-desc">Generate operational reports and monitor progress.</p>
                    </div>
                  </div>
                </div>

                {/* MOCKUP PREVIEW */}
                <div className="login-mockup-section">
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                    <div style={{ display: "flex", gap: "6px" }}>
                      <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#ff5f57", display: "inline-block" }}></span>
                      <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#febc2e", display: "inline-block" }}></span>
                      <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#28c840", display: "inline-block" }}></span>
                    </div>
                    <span style={{ fontSize: "11px", color: "#9ca3af" }}>Orbit · Workspace</span>
                  </div>
                  <div style={{ display: "flex", gap: "16px" }}>
                    {/* Sprint Board */}
                    <div style={{ flex: 1, background: "#f0effe", borderRadius: "12px", padding: "14px" }}>
                      <div style={{ fontWeight: 700, fontSize: "13px", marginBottom: "10px", color: "#1a1a2e" }}>Sprint 24</div>
                      <div style={{ display: "flex", gap: "8px" }}>
                        {["TO DO", "IN-PROGRESS", "COMPLETED"].map((col, colIdx) => (
                          <div key={col} style={{ flex: 1 }}>
                            <div style={{ fontSize: "9px", color: "#9ca3af", fontWeight: 600, marginBottom: "6px", letterSpacing: "0.5px" }}>{col}</div>
                            {[1, 2, 3].map(i => (
                              <div
                                key={i}
                                className="kanban-card"
                                style={{
                                  background: "#fff",
                                  borderRadius: "6px",
                                  padding: "6px 8px",
                                  marginBottom: "5px",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  "--card-delay": `${(colIdx * 3 + i) * 0.15}s`,
                                }}
                              >
                                <div style={{ flex: 1 }}>
                                  <div style={{ height: "5px", background: "#e5e7eb", borderRadius: "3px", marginBottom: "3px", width: "80%" }}></div>
                                  <div style={{ height: "4px", background: "#e5e7eb", borderRadius: "3px", width: "60%" }}></div>
                                </div>
                                <span
                                  className="kanban-dot"
                                  style={{
                                    width: 10,
                                    height: 10,
                                    borderRadius: "50%",
                                    background: "#6366f1",
                                    display: "inline-block",
                                    flexShrink: 0,
                                    "--card-delay": `${(colIdx * 3 + i) * 0.15}s`,
                                  }}
                                ></span>
                              </div>
                            ))}
                          </div>
                        ))}
                      </div>
                    </div>
                    {/* Right Panel */}
                    <div style={{ width: "180px", display: "flex", flexDirection: "column", gap: "10px" }}>
                      {/* Recent Tickets */}
                      <div style={{ background: "#f0effe", borderRadius: "10px", padding: "8px 10px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "5px" }}>
                          <span style={{ fontWeight: 700, fontSize: "11px", color: "#1a1a2e" }}>Recent Tickets</span>
                          <span style={{ fontSize: "10px", color: "#6366f1", fontWeight: 600 }}>8 open</span>
                        </div>
                        {[{ id: "ORB-241", color: "#ef4444" }, { id: "ORB-240", color: "#22c55e" }, { id: "ORB-239", color: "#6366f1" }].map(t => (
                          <div key={t.id} style={{ background: "#fff", borderRadius: "5px", padding: "3px 6px", marginBottom: "3px", display: "flex", alignItems: "center", gap: "5px", fontSize: "10px", color: "#374151" }}>
                            <span style={{ width: 6, height: 6, borderRadius: "50%", background: t.color, flexShrink: 0 }}></span>
                            {t.id}
                          </div>
                        ))}
                      </div>
                      {/* Team Activity */}
                      <div style={{ background: "#f0effe", borderRadius: "12px", padding: "12px" }}>
                        <div style={{ fontWeight: 700, fontSize: "12px", color: "#1a1a2e", marginBottom: "8px" }}>Team Activity</div>
                        <div style={{ display: "flex", alignItems: "flex-end", gap: "4px", height: "40px" }}>
                          {[60, 80, 50, 90, 70, 100, 75, 85].map((h, i) => (
                            <div
                              key={i}
                              className="activity-bar"
                              style={{
                                flex: 1,
                                height: `${h}%`,
                                background: i >= 5 ? "#6366f1" : "#c7d2fe",
                                borderRadius: "3px 3px 0 0",
                                "--bar-delay": `${i * 0.08}s`,
                              }}
                            ></div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </Col>

            {/* RIGHT PANEL */}
            <Col xs={12} md={5}>
  <div className="center-login-card">
   <div className="login-right-wrapper">
      <div className="login-right-card">

        <h2 className="login-right-title">Welcome Back</h2>
        <p className="login-right-subtitle">
          Sign in to access Global Solutions Orbit.
        </p>

                  <Form onSubmit={handleLogin}>
                    <Form.Group className="mb-3" controlId="email">
                      <Form.Label style={{ fontSize: "13px", fontWeight: 500 }}>Email address</Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <i className="bi bi-envelope-fill"></i>
                        </InputGroup.Text>
                        <Form.Control
                          type="email"
                          value={username}
                          onChange={(e) => setUsername(e.target.value)}
                          placeholder="abc@globsolutions.in"
                          autoComplete="email"
                          required
                        />
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="regPassword">
                      <Form.Label style={{ fontSize: "13px", fontWeight: 500 }}>Password</Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <i className="bi bi-shield-lock-fill"></i>
                        </InputGroup.Text>
                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          placeholder="Enter your password"
                          required
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        <InputGroup.Text
                          onClick={() => setShowPassword(!showPassword)}
                          style={{ cursor: "pointer", backgroundColor: "white", borderLeft: "none" }}
                        >
                          {showPassword ? <FaEye /> : <FaEyeSlash />}
                        </InputGroup.Text>
                      </InputGroup>
                    </Form.Group>

                    <div className="login-remember-row">
                      <Form.Check
                        type="checkbox"
                        id="rememberme"
                        label="Remember me"
                        style={{ fontSize: "13px" }}
                      />
                      <span
                        style={{ cursor: "pointer", color: "#4f46e5", fontSize: "13px" }}
                        onClick={() => navigate("/resetpassword")}
                      >
                        Forgot password?
                      </span>
                    </div>

                    <Button
                      className="loginButton"
                      type="submit"
                      onClick={handleLogin}
                    >
                      Sign In →
                    </Button>
                  </Form>

                 <div className="login-protected">
                    Protected workspace for Global Solutions employees and authorized users.
                  </div>

                </div>
              </div>
            </div>
            </Col>

          </Row>
        </div>

        {/* BOTTOM FOOTER */}
        <div className="login-footer">
          <span>© 2026 Global Solutions. All rights reserved.</span>
          <span>orbit.globsolutions.in</span>
        </div>

      </div>

      {/* <Modal show={showSignup} onHide={handleCancel} centered>
        <Modal.Header closeButton>
          <Modal.Title>Create an Account</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSignupSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>
                Name<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={signupData.name}
                onChange={handleNameChange}
                placeholder="Enter Name"
                required
              />
              {nameError && (
                <div
                  style={{
                    color: "red",
                    fontSize: "0.875rem",
                    marginTop: "4px",
                  }}
                >
                  {nameError}
                </div>
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>
                Email<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="email"
                value={signupData.email}
                onChange={handleEmailChange}
                placeholder="Enter Email"
                required
              />
              {emailError && (
                <div
                  style={{
                    color: "red",
                    fontSize: "0.875rem",
                    marginTop: "4px",
                  }}
                >
                  {emailError}
                </div>
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>
                Mobile No.<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="mobile"
                value={signupData.mobile}
                onChange={handleMobileChange}
                placeholder="Enter Mobile No."
                required
              />
              {mobileError && (
                <div
                  style={{
                    color: "red",
                    fontSize: "0.875rem",
                    marginTop: "4px",
                  }}
                >
                  {mobileError}
                </div>
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>
                Password<span className="text-danger">*</span>
              </Form.Label>
              <InputGroup>
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={signupData.password}
                  onChange={handlePasswordChange}
                  placeholder="********"
                  required
                />

                <InputGroup.Text
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    cursor: "pointer",
                    backgroundColor: "white",
                    borderLeft: "none",
                  }}
                >
                  {showPassword ? <FaEye /> : <FaEyeSlash />}
                </InputGroup.Text>
              </InputGroup>

              {passwordError && (
                <div
                  style={{
                    color: "red",
                    fontSize: "0.875rem",
                    marginTop: "4px",
                  }}
                >
                  {passwordError}
                </div>
              )}
            </Form.Group>

            <Modal.Footer className="d-flex justify-content-end">
              <Button
                type="submit"
                className="loginButton"
                onClick={handleSignupSubmit}
                disabled={isSignupLoading}
              >
                {isSignupLoading ? "Processing..." : "Sign Up"}
              </Button>

              <Button variant="secondary" type="button" onClick={handleCancel}>
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal> */}
      <ToastContainer />
    </>
  );
};

export default SignIn;
